var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downId-button",on:{"click":_vm.handleDownload}},[_vm._v("下载身份证照片")])
}
var staticRenderFns = []

export { render, staticRenderFns }